module.exports = __webpack_public_path__ + "img/Terpin.a603d152.jpg";